import * as React from 'react';
import { LinearProgress } from '@material-ui/core';
import TableauReport from '../Report/TableauReport';
import strings from 'src/strings';
import { DefaultGraphProps } from '../Report';
import { UsersAPI } from 'src/api';

let existing_classes = {}
interface GenericreportState { height?: number, width?: number, loading: boolean, token?: string }
export class AgencyReport extends React.Component<{ accountid: string }, GenericreportState> {

    private _divElement: HTMLDivElement | null;
    set divElement(value) {
        this._divElement = value
        this.didUpdateSize()
    }
    get divElement() {
        return this._divElement;
    }
    private report: TableauReport;

    private knownSize: { width: number, height: number }

    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            token: undefined
        }
    }

    static title() {
        return 'Agency Report'
    }

    static identifier() {
        return "Agency Report.name"
    }

    componentDidMount() {
        this.loadToken()
    }

    loadToken() {
        UsersAPI.getTableauToken().then((token: string) => {
            this.setState({ token: token, loading: false })
        }).catch(err => {
            this.setState({ loading: false })
        })
    }

    export() {
        this.report && this.report.export()
    }

    didUpdateSize() {
        if (this.divElement) {
            const height = this.divElement.clientHeight;
            const width = this.divElement.clientWidth;
            if (height != this.state.height || width != this.state.width) {
                this.setState({ height, width }, () => {
                })
            }
        }
    }

    public render() {
        return <div style={{ height: '100%' }} ref={(divElement) => {
            this.divElement = divElement
        }}>
            {this.state.loading && <LinearProgress />}
            {this.state.width && this.state.token && <TableauReport
                ref={(ref) => {
                    this.report = ref!
                    if (this.report && this.report.getIFrame()) {
                    }
                }}
                token={this.state.token}
                url={process.env.REACT_APP_TAB_URL + "/views/AgencyDashboard/HeadlineDashboard"}
                filters={{ parentaccountid: this.props.accountid }}
                onLoad={() => {
                    this.setState({ loading: false }, () => {
                        //this.knownSize && this.props.options.onSizeKnown(this.knownSize.width, this.knownSize.height)
                    })
                }}
                options={{
                    width: this.state.width,
                    height: this.state.height,
                    hideTabs: false,
                    hideToolbar: true,
                    onFirstVizSizeKnown: (e: any) => {
                        this.knownSize = e.getVizSize().sheetSize.minSize

                    }
                }} parameters={{}}
            />}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/AgencyReport/AgencyReport.tsx